import {
    createBaseQueries,
    transformErrorResponse,
    transformSuccessResponse,
    buildFormData,
    EXTERNAL_URL,
} from "@/services";
import { createApi } from "@reduxjs/toolkit/query/react";

const { rawExternalApiBaseQuery: educationDashboardBaseQuery } = createBaseQueries({
    externalURLType: EXTERNAL_URL.appRoot,
});

const educationDashboardAPI = createApi({
    reducerPath: "educationDashboardAPI",
    baseQuery: educationDashboardBaseQuery,
    tagTypes: ["EducationDashboard"],
    endpoints: (builder) => ({
        getEducationDashboardList: builder.query({
            query: ({ page = 0, size = 10, searchText = "", sortBy = "", sortDir = "" } = {}) => ({
                url: `/util/dashboard`,
                method: "GET",
                params: {
                    ...(page !== undefined && { page }),
                    ...(size !== undefined && { size }),
                    ...(searchText !== undefined && searchText !== null && searchText !== "" && { searchText }),
                    ...(sortBy !== undefined && sortBy !== null && sortBy !== "" && { sortBy }),
                    ...(sortDir !== undefined && sortDir !== null && sortDir !== "" && { sortDir }),
                },
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            providesTags: ["EducationDashboard"],
        }),
        getEducationDashboardById: builder.query({
            query: (id) => ({
                url: `/util/dashboard/${id}`,
                method: "GET",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        addEducationDashboard: builder.mutation({
            query: ({ dashboardRequestDTO, file }) => ({
                url: `/util/dashboard`,
                method: "POST",
                body: buildFormData({ dashboardRequestDTO, file }),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ["EducationDashboard"],
        }),
        updateEducationDashboard: builder.mutation({
            query: ({ dashboardRequestDTO, file }) => ({
                url: `/util/dashboard`,
                method: "PUT",
                body: buildFormData({ dashboardRequestDTO, file }),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ["EducationDashboard"],
        }),
        deleteEducationDashboard: builder.mutation({
            query: (id) => ({
                url: `/util/dashboard/${id}`,
                method: "DELETE",
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
            invalidatesTags: ["EducationDashboard"],
        }),
    }),
});

export const {
    useGetEducationDashboardListQuery,
    useLazyGetEducationDashboardListQuery,
    useGetEducationDashboardByIdQuery,
    useLazyGetEducationDashboardByIdQuery,
    useAddEducationDashboardMutation,
    useUpdateEducationDashboardMutation,
    useDeleteEducationDashboardMutation,
} = educationDashboardAPI;

export default educationDashboardAPI;
